/// <reference path="./SelectorItem.ts" />
namespace HA.Core.HTML.Editor {
    export class ImageItem extends SelectorItem {
    }
}
